import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceScreeningHistoryLogsService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-screening`;

    static getInstance() {
        if (!ComplianceScreeningHistoryLogsService.instance) {
            ComplianceScreeningHistoryLogsService.instance = new ComplianceScreeningHistoryLogsService();
        }

        return ComplianceScreeningHistoryLogsService.instance;
    }

    async fetchLogs(params = {}) {
        const response = await axios.get(
            `${KYB_API_BASE_URL}/logs`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data || [];
    }
}
